import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { HttpServices } from "./httpservices/http.service";

import { Md5 } from 'ts-md5/dist/md5';

import { GlobalVariable } from '../app.globalvariable';
import { CommonEncrypt } from "../utils/common.encrypt";
@Injectable()

export class AuthService {



    constructor(private datasource: HttpServices) { }


    random(): Observable<string> {

        this.datasource.random().subscribe(p => {
            if (p.resultCode == '100000') {
                //通知重新更新列表
                GlobalVariable.setMacKey(p.resultInfo.macKey);
                GlobalVariable.setSessionID(p.resultInfo.sessionID);
                GlobalVariable.setToken(p.resultToken);
            }
        })

        return null;
    }


    authenticate(mobile: string, password: string): Observable<string> {
        GlobalVariable.setDeviceID('Browser001');
        var passwordEncrypt = CommonEncrypt.encryptData(password, GlobalVariable.getMacKey());
        return this.datasource.authenticate1(CommonEncrypt.encryptData(mobile, GlobalVariable.getMacKey()), passwordEncrypt);

    }

    get authenticated(): boolean {

        return GlobalVariable.getAuthToken() != null;

    }

    getMacKey() {
        return GlobalVariable.getMacKey();
    }

    clear() {

        GlobalVariable.setAuthToken(null);

    }

    logout() {
        GlobalVariable.setSessionID('');
    }

    check()
    {
        return GlobalVariable.getSessionID();
    }

}